export class CategoryCreateRequestModel {
  public name: string;
  public keys: Array<string> = new Array<string>();
}
